import { AxiosResponse } from "axios";

import {
  IAddLanguageToSurveyRequest,
  IAddLanguageToSurveyResult,
  ISurveyLanguage,
  ISurveyListItem,
  ISurveyTranslation,
  IUpdateSurveyTranslationRequest,
} from "../../@types/admin/AdminSurveyTranslation";
import { api } from "../api";

/**
 * Survey translations admin page (EN-5163), migrated from the Retool
 * SurveyTranslations app.
 */
export const surveyTranslationsService = {
  /** Surveys that can be translated — the picker. */
  async getSurveys(): Promise<AxiosResponse<ISurveyListItem[]>> {
    return api.get<ISurveyListItem[]>("/Retool/SurveyTranslations/Surveys");
  },

  /** Every translation row for one survey, across all its languages. */
  async getSurveyTranslations(
    surveyId: string
  ): Promise<AxiosResponse<ISurveyTranslation[]>> {
    return api.get<ISurveyTranslation[]>(
      `/Retool/SurveyTranslations/Surveys/${surveyId}/Translations`
    );
  },

  /** Language catalogue for the add-language action. */
  async getLanguages(): Promise<AxiosResponse<ISurveyLanguage[]>> {
    return api.get<ISurveyLanguage[]>("/Retool/SurveyTranslations/Languages");
  },

  /** Saves ONE row — the endpoint has no bulk form. */
  async updateTranslation(
    request: IUpdateSurveyTranslationRequest
  ): Promise<AxiosResponse<ISurveyTranslation>> {
    return api.put<ISurveyTranslation>(
      "/Retool/SurveyTranslations/Translations",
      request
    );
  },

  /** Seeds a survey's strings in a new language; reports created vs skipped. */
  async addLanguageToSurvey(
    surveyId: string,
    request: IAddLanguageToSurveyRequest
  ): Promise<AxiosResponse<IAddLanguageToSurveyResult>> {
    return api.post<IAddLanguageToSurveyResult>(
      `/Retool/SurveyTranslations/Surveys/${surveyId}/Languages`,
      request
    );
  },
};
